import { GET_ALL_CONFERENCIAS, GET_CONFERENCIA } from './mutation-types'
import conferenciaHttpService from '../_services/conferenciaHttpService'

export default {
  listarConferencias: async ({ commit }) => {
    try {
      const response = await conferenciaHttpService.getConferencias()
      commit(GET_ALL_CONFERENCIAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarUmaConferencia: async ({ commit }, _id) => {
    try {
      const response = await conferenciaHttpService.getConferencia(_id)
      commit(GET_CONFERENCIA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
